import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the user logs table view.
 * @extends JetView
 */
export default class tableLogsUserView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            rows: [
                {
                    cols: [
                        {
                            view: 'datatable', // Data table view
                            id: 'datatable', // Unique identifier for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
                            height: screen.width < 820 ? 405 : 0, // Conditional height based on screen width
                            columns: [
                                // Column definitions
                                {
                                    id: 'Id',
                                    header: 'Id',
                                    width: 100,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Date',
                                    header: _('Fecha'), // Localized header
                                    fillspace: 0,
                                    minWidth: 0,
                                    width: 200,
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date formatting
                                },
                                {
                                    id: 'Type',
                                    header: _('Tipo'), // Localized header
                                    width: 200,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Table',
                                    header: _('Elemento'), // Localized header
                                    width: 200,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Field',
                                    header: _('Campo'), // Localized header
                                    width: 200,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ExternalId',
                                    header: _('ID Externo'), // Localized header
                                    width: 200,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ValuePrevius',
                                    header: _('Valor antes'), // Localized header
                                    width: 200,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Value',
                                    header: _('Valor despues'), // Localized header
                                    width: 200,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Reason',
                                    header: _('Razon'), // Localized header
                                    width: 200,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserModified',
                                    header: _('Usuario Modificó'), // Localized header
                                    width: 200,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'IP',
                                    header: _('Dirección IP'), // Localized header
                                    width: 200,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'OS',
                                    header: _('Sistema operativo'), // Localized header
                                    width: 200,
                                    sort: 'int', // Sorting type
                                },
                            ],
                            on: {
                                // Event handlers for the datatable
                                onBeforeLoad: function () {
                                    // Before loading data
                                    this.showOverlay(
                                        // Show loading overlay
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                onAfterLoad: function () {
                                    // After loading data
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            ready: function () {
                                // When the datatable is ready
                                if (!this.count()) {
                                    // Check if there are no rows
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        // Show no data overlay
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    );
                                }
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                            // Data source URL
                            url: devConfig.geturlApi() + 'null/Report/GetLogsUserGeneral',
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the datatable instance
        var url = grid.data.url; // Store the data URL
        var filter = ''; // Initialize filter string
        this.on(this.app, 'logsUser:filter', (filterData) => {
            // Event listener for filtering logs
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object filters
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filter
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object filter to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object filters
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format start date
                                    string1 = string1 + '&' + dateFrom; // Add start date to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format end date
                                        string1 = string1 + '&' + dateTo; // Add end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter string
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event listener for sorting
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });
        grid.attachEvent('onDataRequest', function (start, count) {
            // Event listener for data requests
            custom_load(this.data.url, start, count); // Custom load function
            return true; // Allow default behavior
        });
        /**
         * Custom load function to fetch data.
         * @param {string} url - The data URL.
         * @param {number} start - The starting index for data.
         * @param {number} count - The number of records to fetch.
         */
        function custom_load(url, start, count) {
            grid.load(url + '?start=' + start + '&count=' + count); // Load data with pagination
        }
        this.on(this.app, 'player:select', (id) => {
            // Event listener for player selection
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + id, // Load data filtered by selected player
            );
        });
    }
}

// FILE DOCUMENTED
